module.exports = __webpack_public_path__ + "img/Character_Scaramouche_Thumb.43f7012f.png";